import React from 'react';
import './AdminKbd.css';

/**
 * @param {{
 *   children?: React.ReactNode,
 *   className?: string
 * }} props
 */
function AdminKbd({ children, className = '' }) {
  return <kbd className={`au-kbd au-scope${className ? ` ${className}` : ''}`}>{children}</kbd>;
}

export default AdminKbd;
